import { Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/i18n';
import React, { useCallback } from 'react';
import { BiCtaNames, BiModalTypes } from '../../bi/types';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { useAnalyzeFullSiteQuery } from '../../queries/use-analyze-full-site-query';
import { buildStudioDialogProps } from '../modals/build-studio-dialog-props';
export const useDomOrderConfirmationModal = () => {
  const biLogger = useBiLogger();
  const {
    refetch: analyzeFullSite
  } = useAnalyzeFullSiteQuery();
  const {
    a11yWizardAdapter,
    capabilities
  } = useA11yWizardAdapter();
  const {
    t
  } = useTranslation();
  const showConfirmationModal = useCallback(async () => {
    const modalProps = {
      ...getConfirmationModalProps(t, capabilities.usesClassicModalChrome),
      primaryButtonOnClick: async () => {
        biLogger.modalCtaClick({
          ctaName: BiCtaNames.ProceedWithout,
          modalType: BiModalTypes.ProceedWithoutAutoDOM
        });
        await analyzeFullSite();
      },
      secondaryButtonOnClick: () => {
        biLogger.modalCtaClick({
          ctaName: BiCtaNames.Cancel,
          modalType: BiModalTypes.ProceedWithoutAutoDOM
        });
      }
    };
    if (capabilities.usesClassicModalChrome) {
      await a11yWizardAdapter.showDialog({
        ...modalProps,
        theme: modalProps.skin
      });
      return;
    }
    await a11yWizardAdapter.showDialog(...buildStudioDialogProps(modalProps));
  }, [a11yWizardAdapter, analyzeFullSite, biLogger, capabilities, t]);
  return {
    showConfirmationModal
  };
};
export const getConfirmationModalProps = (t, usesClassicModalChrome) => ({
  content: usesClassicModalChrome ? t('accessibility-wizard.footer.dom-order.confirmation-modal.content') : /*#__PURE__*/React.createElement(Text, null, t('accessibility-wizard.footer.dom-order.confirmation-modal.content')),
  primaryButtonText: t('accessibility-wizard.footer.dom-order.confirmation-modal.primary-button'),
  secondaryButtonText: t('accessibility-wizard.footer.dom-order.confirmation-modal.secondary-button'),
  skin: 'standard',
  title: t('accessibility-wizard.footer.dom-order.confirmation-modal.title')
});
//# sourceMappingURL=dom-order-confirmation-modal.js.map